<template>
	<div>
		<layout>
			<!--vestigingen Area Start -->
            <pagetitle>ONZE VESTIGINGEN</pagetitle>
            <div class="row">
            	<div class="col-sm-4" v-for="(branch, index) in branches" :key="index">
		            <div class="card">
					  	
					  	<img class="card-img-top" :src="branch.image" :alt="branch.title" />
					  	<div class="card-body">
						    <h5 class="card-title" v-html="branch.title"></h5>
					    	<div class="card-text" v-html="branch.content"></div>
					    	<a :href="'/branch/'+branch.id" class="btn btn-theme mt-3">Naar vestiging...</a>
					  </div>
					</div>
				</div>
			</div>
			
		</layout>
	</div>
</template>

<script>
import layout from '../layout/layout.vue'

export default {

	name: 'branches',
	
	components:{
		layout,
	},

	data () {
		return {
			branches : []
		}
	},
	created(){
	    window.console.log(JSON.parse(localStorage.getItem('user')));

	    // REQUESTING FOR ALL AVAILABLE BRANCHES
	    this.$store.dispatch("get",this.$store.state.endpoint+'branches?token='+this.$store.state.token)
	    .then(data=>{  
	        this.branches=data.data.data;
	        window.console.log('data',data); 
	       
	    }) 
	    .catch(error=>{
	        if(error.request.status == 401){
	            this.error=true;
	            this.error_msg="invalid login details";
	        }
	    });
	}
}
</script>

<style lang="css" scoped>
</style>